import { API_STATUS_CODES } from '@/constants/request'

const IGNORE_HTTP_CODES = [
  API_STATUS_CODES.APPLICATION_NOT_AUTH,
  API_STATUS_CODES.REQUEST_NOT_AUTH,
]

export function ignoreHttpStatus(exception: any) {
  const httpStatus = exception?.response?.status as number
  return IGNORE_HTTP_CODES.includes(httpStatus)
}

export function ignoreHttpBusinessError(exception: any) {
  const isBusinessError = exception?.response?.data?.success === false
  return Boolean(isBusinessError)
}

export function ignoreAntdFormError(exception: any) {
  const isAntdFormError = exception?.errorFields
  return Boolean(isAntdFormError)
}

export default function ignoreError(exception: any) {
  return [ignoreHttpStatus, ignoreAntdFormError, ignoreHttpBusinessError].some(
    fn => fn(exception),
  )
}
